// extracted by mini-css-extract-plugin
module.exports = {"formSwitchButtons":"FormSwitcher_formSwitchButtons__2qHpi","button":"FormSwitcher_button__3XNRq","active":"FormSwitcher_active__1cyiA"};